module.exports = __webpack_public_path__ + "static/media/ic_upload_file.b549598f.svg";